import { render, staticRenderFns } from "./RateList.vue?vue&type=template&id=69c71f2c&scoped=true"
import script from "./RateList.vue?vue&type=script&lang=js"
export * from "./RateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c71f2c",
  null
  
)

export default component.exports